module.exports = __webpack_public_path__ + "static/media/logo.6557c2d5.svg";